class exports.RuppOrdersDialogHandler extends FullPageHandler

    constructor: () ->
        super()
        @saveData = {}
        @crop = null
        # the message writer has weird issues with initialization
        # reinitialize it in the afterLoadLayout() of each step to fix it
        @useMessageWriter = true
        @editable = true


    _handleResize: () ->
        @dialog.find('#orders_container').css 'height': '100%'
        @dialog.find('#orders_steps_container').resizr()
        super()
        @dialog.find('.orders_customer_container').resizr()


    init: () ->
        @saveUrl = 'backend/grower/rupp-orders/save-order'
        @currentStep = null

        @subHandlers =
            Customers:
                class: 'grower::handlers/rupp_orders/steps/RuppOrdersDialogCustomersHandler'
                attrs:
                    prevStep: null
                    nextStep: 'Lines'
            Lines:
                class: 'grower::handlers/rupp_orders/steps/RuppOrdersDialogLinesHandler'
                attrs:
                    prevStep: 'Customers'
                    nextStep: 'Discounts'
            Discounts:
                class: 'grower::handlers/rupp_orders/steps/RuppOrdersDialogDiscountsHandler'
                attrs:
                    prevStep: 'Lines'
                    nextStep: null

        @firstStep = 'Customers'

        @layoutUrl = 'backend/grower/rupp-orders/load-layout-dialog'
        @refreshNavHandler = false
        @successAction = @saveSuccessful
        @errorAction = @saveFailed
        @destroyOnSave = true
        @createDialog()

        @dynamicButtonSelectors =
            'customers': '#btn_add_customer'
            'lines': '#btn_add_line'
            'discounts': '#btn_add_discount'
            'address': null

        @dynamicObjNames = {}
        for k, v of @dynamicButtonSelectors
            @dynamicObjNames[v] = k


    gotoNext: () ->
        $('#btn_orders_next').prop('disabled', true)
        @gotoStep(@currentStep.nextStep)

    gotoPrev: () ->
        @gotoStep(@currentStep.prevStep)

    gotoStep: (step) ->
        return if not step?

        @saveFormData()
        step = @createSubHandler(step)
        if step
            step.loadLayoutPostOptions =
                JSON.stringify @saveData
            step.init()
            @currentStep = step
            @handleNavButtons()
            return step


    afterLoadLayout: (selector, response) ->
        @openDialog()

        if response.status?.type isnt 'success'
            return

        @saveData = $.extend true, response.data['order'], @saveData
        debugLog 'afterLoadLayout'
        debugLog @saveData

        @gotoStep(@firstStep)

        @handleNavButtons()

        @dialog.find('#btn_orders_next').bind 'click', () =>
            if @currentStep.validator?
                if @currentStep.validator.validating is false
                    @currentStep.validator.startValidating()
                @currentStep.validator.validateAll()
            else
                @gotoNext()

        @dialog.find('#btn_orders_prev').bind 'click', () =>
            @gotoPrev()

        @msg = @dialog.find('.message_writer')


    handleNavButtons: () ->
        if @currentStep.prevStep
            $('#btn_orders_prev').prop('disabled', false)
        else
            $('#btn_orders_prev').prop('disabled', true)

        nextBtn = $('#btn_orders_next')
        nextBtn.show()
        if @currentStep.nextStep
            nextBtn.removeClass('save-btn').find('.btn-text').html('Next')
        else
            nextBtn.addClass('save-btn').find('.btn-text').html('Save')
            if not @editable
                nextBtn.hide()


    getPostData: () ->
        #console.log @saveData
        return JSON.stringify @saveData


    saveFormData: () ->

        #if @saveData.lines?
        #    console.log "pre save form"
        #    console.log $.parseJSON(ko.toJSON(@saveData.lines))

        for elem in $('.order-data')
            elem = $(elem)
            name = elem.attr('name')

            if elem.is('select') or elem.is('input') or elem.is('textarea')
                val = elem.val()
            else
                val = elem.text()

            dynamic_id = elem.data('dynamic-id')
            if not dynamic_id?
                @saveData[name] = val
            else
                btn = elem.data('dynamic-btn')
                obj_name = @dynamicObjNames[btn]

                # Check to make sure that the object for this button exists
                if not @saveData[obj_name]?
                    @saveData[obj_name] = {}
                arr = @saveData[obj_name]

                # Check to make sure that an object for this id exists
                if not arr[dynamic_id]?
                    arr[dynamic_id] = {}
                obj = arr[dynamic_id]

                # Now we know that obj holds the save data for this element
                obj[name] = val

        #if @saveData.lines?
        #    console.log "saving form"
        #    console.log $.parseJSON(ko.toJSON(@saveData.lines))
        #console.log "saveFormData: saveData"
        #console.log @saveData


    # The cyclomatic complexity is too damn high 19.
    # NO KIDDING
    loadFormData: () ->
        for elem, val of @saveData
            if $.isArray(val)
                val = @saveData[elem] = $.extend {}, val
            # just an ordinary key/value pair
            if typeof val isnt 'object'
                sel = "[name='#{elem}']:first"
                sel = $(sel)
                if sel.length isnt 0
                    tag = sel.prop('tagName')
                    if tag is 'INPUT' or tag is 'SELECT'
                        sel.val(val).trigger('change')
                    else
                        sel.html(val)

            # here we have an object, which is probably an array of dynamic elements with numeric indexes
            else if val?
                btn = @dynamicButtonSelectors[elem]

                # don't bother doing anything if the button to add new dynamic elements doesn't exist
                # (or we don't need one)
                if btn is null or $(btn).length isnt 0
                    for i, obj of val
                        # http://stackoverflow.com/questions/18082/validate-numbers-in-javascript-isnumeric
                        # if the key is not numeric, just try to set the input with the name of the key
                        if not (not isNaN(parseFloat(i)) and isFinite(i))
                            selName = "[name='#{i}']"
                            selData = '[data-non-dynamic=1]'
                            sel = selName + selData
                            if $(sel).length isnt 0
                                $(sel).val(obj)

                        # otherwise we should loop over each dynamic input
                        else
                            obj = val[i]
                            for name, value of obj
                                # flatten the object if needed
                                if typeof value is 'object'
                                    for k, v of value
                                        @setLoadFormData k, i, btn, v
                                else
                                    @setLoadFormData name, i, btn, value

                                # At this point, we are so far deep in this object's structure that it would probably be
                                # best to rewrite this function recursively and genericly. The rules could be:
                                # 1. Iterate over k, v pairs in the object
                                # 2. If v is an object, recurse on v, passing in k as the selector container
                                #      else,
                                # 3. If a selector container is specified, prefix all selectors with
                                #       ".<param>-container"
                                # 4. If a selector index is specified, postfix all selectors with
                                #       "[data-dynamic-id=<param>]"
                                # 4. If the key is not numeric, set the input name=key to the value
                                #      If the input does not exist and the selector container is specified,
                                #      get the button for the container, click it, and try again
                                # 5. If the key is numeric, iterate over the i,obj pairs. For each pair, recurse on obj,
                                #      passing in i as the selector index

        ###
        DISABLE GROWER EDITING
        ###
        if @saveData.can_edit_order? and @saveData.can_edit_order is false
            @editable = false
            @dialog.find('input,select,textarea,.btn').each () ->
                if not ($(this).attr('id') in ['btn_orders_prev', 'btn_orders_next'])
                    $(this).attr 'disabled', 'disabled'

        debugLog 'loadFormData: saveData'
        debugLog(@saveData)
        @currentStep.afterLoadData()


    setLoadFormData: (name, dynamic_id, btn, value) ->
        selName = "[name='#{name}']"
        selData = "[data-dynamic-id='#{dynamic_id}']"
        sel = selName + selData

        # Only try to click the button if we can't find the element
        # and there are no other elements with this data id
        if $(sel).length is 0 and $(selData).length is 0 and btn
            $(btn).data('id', dynamic_id)
            $(btn).click()

        if $(sel).length isnt 0
            if $(sel).is('input') or $(sel).is('select')
                $(sel).val(value).trigger('change')
            else
                $(sel).html(value)


    deleteFormData: (name, dynamic_id) ->
        if @saveData[name]? and @saveData[name][dynamic_id]?
            delete @saveData[name][dynamic_id]


    saveSuccessful: (data) ->
        @msg.message_writer('success', 'Order saved')
        try
            if data.data['openpdf'] is true
                filename = data.data['filename']
                name = data.data['name']
                date = data.data['date']
                url = "backend/grower/rupp-orders/show-pdf?filename=#{filename}&date=#{date}"
                window.open(url)
        catch e
            # data probably undefined; don't really care
        @reopenSidebar()


    saveFailed: (data) ->
        @msg.message_writer('error', 'An error occurred while saving your order. Please try again later.')


    reopenSidebar: () ->
        if not App.sidebar.isOpen
            App.sidebar.element.find('.map_sidebar_hide').click()
        @parent.orderCompleted?()
